import { render, staticRenderFns } from "./ViewKeyPointModal.vue?vue&type=template&id=2b2b075d&scoped=true"
import script from "./ViewKeyPointModal.vue?vue&type=script&lang=js"
export * from "./ViewKeyPointModal.vue?vue&type=script&lang=js"
import style0 from "./ViewKeyPointModal.vue?vue&type=style&index=0&id=2b2b075d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b075d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2b075d')) {
      api.createRecord('2b2b075d', component.options)
    } else {
      api.reload('2b2b075d', component.options)
    }
    module.hot.accept("./ViewKeyPointModal.vue?vue&type=template&id=2b2b075d&scoped=true", function () {
      api.rerender('2b2b075d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassMood/compoents/ViewKeyPointModal.vue"
export default component.exports